import { createAsyncThunk } from "@reduxjs/toolkit";
import { IReviewPayload } from "../../utility/types/reviewType";
import {
  submitCreateReview,
  submitGetAllReviews,
  submitGetUserReview,
} from "../services/reviewService";

export const createReview = createAsyncThunk(
  "review",
  async (payload: IReviewPayload, { rejectWithValue }) => {
    try {
      const response = await submitCreateReview(payload);

      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data.message || error.message);
    }
  }
);

export const getUserReview = createAsyncThunk(
  "user/review",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await submitGetUserReview(userId);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data.message || error.message);
    }
  }
);

export const getAllReviews = createAsyncThunk(
  "reviews",
  async (_, { rejectWithValue }) => {
    try {
      const response = await submitGetAllReviews();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data.message || error.message);
    }
  }
);
